import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';
import { echartsContent, initialUpperCase } from '@/pages/opinion/utils';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';
import { percentageFormat, reviewsFormat } from '@/pages/opinion/utils/value';
import { getChartBufferWidth } from '@op/utils/systemUtil';
import React from 'react';
import { useMemo } from 'react';
import { Justify } from 'tea-component';
import { useIntl } from 'umi';

export default function LineCharts({
  dateType,
  lineData,
  loading,
  height = 140,
}: any) {
  const { formatMessage } = useIntl();
  const [options, noData] = useMemo(() => {
    let { recommend, non_recommend, xAxis } = lineData || {};
    let options = {
      color: ['#0ABF5B', '#E54545'],
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          // 时间
          let dataTime = '';
          if (params.length > 0) {
            dataTime = listTimeTitleFunc(params[0]?.axisValue, dateType);
          }

          return formatChartParamsDate({
            params: params,
            valueFormat: reviewsFormat,
            listTitleFunc: (item) => initialUpperCase(item.seriesName),
            dealwithRecords: (records, total) => {
              let newRecords = records.map((item) => ({
                ...item,
                text: formatMessage({ id: item.originText }),
                share: percentageFormat((item.originValue / total) * 100),
              }));
              newRecords.unshift({
                text: formatMessage({ id: 'Sum' }),
                value: reviewsFormat(total),
                share: '100%',
                originValue: total,
                originText: 'Sum',
              });

              return newRecords;
            },
            tablesConfigFunc: (records) => {
              return [
                {
                  showHeader: true,
                  records,
                  columns: [
                    {
                      key: 'text',
                      header: dataTime,
                    },
                    {
                      key: 'value',
                      align: 'right',
                      weight: 'bold',
                      header: formatMessage({ id: 'Reviews' }),
                    },
                    {
                      key: 'share',
                      align: 'right',
                      weight: 'bold',
                      header: formatMessage({ id: 'Share-1' }),
                    },
                  ],
                },
              ];
            },
          });
        },
      },
      legend: {
        show: false,
      },
      grid: {
        top: 20,
        left: getChartBufferWidth(5),
        right: 22,
        bottom: 0,
        containLabel: true,
      },
      axisPointer: getAxisPointer((data) =>
        formatTimeXAxisText(data.value, dateType),
      ),
      xAxis: {
        boundaryGap: false,
        data: xAxis,
        axisLabel: {
          formatter: (value: any) => formatTimeXAxisText(value, dateType),
        },
      },
      yAxis: {
        type: 'value',
        splitNumber: 2,
        min: 'dataMin',
        max: 'dataMax',
        axisLabel: {
          formatter: (value: any) => {
            return echartsContent(value);
          },
        },
      },
      series: [
        {
          name: 'positive',
          type: 'line',
          data: recommend,
        },
        {
          name: 'negative',
          type: 'line',
          data: non_recommend,
        },
      ],
    };

    return [options, xAxis?.length === 0];
  }, [lineData, formatMessage]);

  return (
    <div style={{ lineHeight: 1 }}>
      {!noData && (
        <Justify
          left={
            <span style={{ color: '#838697', fontSize: 14 }}>
              {formatMessage({ id: 'Reviews' })}
            </span>
          }
        ></Justify>
      )}
      <EChartCommon
        options={options}
        loading={loading}
        empty={noData}
        height={height}
        hasEmptyImg={false}
        hasEmptyTitle={false}
      ></EChartCommon>
    </div>
  );
}
